import { Phone } from "lucide-react";
import { images, resort } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function AmenitiesMidCTA() {
  return (
    <section
      aria-labelledby="amenities-mid-cta-heading"
      className="relative isolate overflow-hidden bg-primary text-primary-foreground"
    >
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-16 md:py-18">
        <Reveal>
          <Eyebrow tone="light">Everything You Need Is Here</Eyebrow>
        </Reveal>
        <h2 id="amenities-mid-cta-heading" className="display-lg mt-6 max-w-[12ch]">
          <MaskReveal>Ready to Settle In?</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg">
            Choose your travel dates and let Auburn RV Resort help you find the right available site
            for your stay.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
              Check Availability
            </ResortLink>
            <ResortLink variant="onDark" href={resort.phoneHref} className="w-full sm:w-auto">
              <Phone className="size-4" strokeWidth={1.6} /> Call the Resort
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
